import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

import {
  useTheme,
} from '@mui/material';

import logoimg from '../assets/img/logo.png';
import titleimg from '../assets/img/true_extract.png';
import AppDelegate from "../AppDelegate";


const VerticalMenu = styled.div`
  display: none;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;

  &.active {
    max-height: 200px;
  }

  @media only screen and (max-width: 640px) {
    display: block;
  }
`;

const MenuItem = styled.div`
  width: 100%;
  height: 55px;
  font-size: 1.5rem;
  text-align: center;
  cursor: pointer;
`

const LogoutButton = styled.button`
  border: none;
  background: transparent;
  color: #0f766e;
  cursor: pointer;
  font: inherit;
  padding: 0px 14px;

  &:hover {
    background: #0f766e;
    color: white;
  }
`;

const Topbar = (props) => {
  const theme = useTheme();
  const navigate  = useNavigate();
  const [menuOpened, setMenuOpened] = useState(false);
  const isLoggedIn = Boolean(AppDelegate.user?.jwt);

  //---------------------------------------------------------------------

  const toggleMenu = (open) => {
    if (open !== undefined) {
      setMenuOpened(open);
    } else {
      setMenuOpened(!menuOpened);
    }
  };

  const onClickHome = (e) => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  const goto = (href) => {
    toggleMenu(false);

    window.location.href = href;
  };

  const logout = () => {
    AppDelegate.clearSession();
    toggleMenu(false);
    navigate("/");
  };

  return (
    <header>
      <div className="container">
        <nav>
          <div className="logo-container" onClick={onClickHome}>
            <img src={logoimg} alt="True-Extract Logo" className="logo" />
            <img src={titleimg} alt="True-Extract" className="brand-name" />
          </div>

          <div className="menu-button" onClick={() => toggleMenu()}>
            <svg width="48" height="48" viewBox="0 0 48 48" aria-hidden="true">
              <line x1="12" y1="16" x2="36" y2="16" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="12" y1="24" x2="36" y2="24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
              <line x1="12" y1="32" x2="36" y2="32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
            </svg>
          </div>


          <ul className="nav-links">
            <li><a href="/#about">About</a></li>
            <li><a href="/#services">Services</a></li>
            <li><a href="/#contact">Contact</a></li>
            {/* {isLoggedIn && (
              <li>
                <LogoutButton onClick={logout}>Logout</LogoutButton>
              </li>
            )} */}
          </ul>

        </nav>
        <VerticalMenu className={menuOpened ? 'active' : ''}>
          <MenuItem><div onClick={() => goto("/")}>Home</div></MenuItem>
          <MenuItem><div onClick={() => goto("/#about")}>About</div></MenuItem>
          <MenuItem><div onClick={() => goto("/#services")}>Services</div></MenuItem>
          <MenuItem><div onClick={() => goto("/#contact")}>Contact</div></MenuItem>
          {isLoggedIn && <MenuItem><div onClick={logout}>Logout</div></MenuItem>}
        </VerticalMenu>
      </div>
    </header>


  );
};

export default Topbar;
